// extracted by mini-css-extract-plugin
export default {"thanks":"jYVdCT","logoContainer":"kLdpSN","logo":"tbGCvM","toast":"aWnHTQ","title":"UtHTbe","invoiceNum":"SP1uaH","message":"J1on9g","finishBtn":"fQdHKy"};